/**
 * "Näytä ostoskori" in the added-to-cart notice opens the side cart.
 *
 * After a product is added from its page, WooCommerce's notice links to the
 * cart page; the cart icon beside the header (or the breadcrumbs) opens the
 * same cart in a drawer, without leaving the product. The link now does what
 * the icon does. Only a plain click: one with a modifier key, or with no cart
 * icon showing to open, still goes to the cart page.
 *
 * Told apart from the notice's other links by where it points: the cart page,
 * whose address lib/woocommerce.php passes as window.diakonStore.cartUrl.
 */
export function initCartNoticeDrawer() {
	const cartUrl = window.diakonStore?.cartUrl;

	if (!cartUrl) {
		return;
	}

	const cartPath = new URL(cartUrl, window.location.href).pathname;

	document.addEventListener('click', (event) => {
		if (
			event.defaultPrevented ||
			event.button !== 0 ||
			event.metaKey ||
			event.ctrlKey ||
			event.shiftKey ||
			event.altKey
		) {
			return;
		}

		const link = event.target.closest('a.wc-forward[href]');

		if (
			!link ||
			new URL(link.href, window.location.href).pathname !== cartPath
		) {
			return;
		}

		// The one on show: a store draws the cart in the header or beside
		// the breadcrumbs, and a hidden one has no drawer to open here.
		const icon = [
			...document.querySelectorAll('.wc-block-mini-cart__button'),
		].find((button) => button.offsetParent !== null);

		if (!icon) {
			return;
		}

		event.preventDefault();
		icon.click();
	});
}
